<script setup>
    import router from '../router';
    import { useI18n } from 'vue-i18n';

    const { t } = useI18n();

defineProps({
    transaction: {
        type: Object
    },
    darkmode: {
        type: Boolean,
        default: false
    }
});

function formatMoney(v) {
      let total = parseFloat(v);

      return total.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
      });
}

function formatDate(d){
    
    let date = new Date(d);
    
    return date.toLocaleDateString(t('message.global.date_language'), {timeZone: 'UTC'});

}



const emit = defineEmits(['edit', 'pay']);

const editTrasaction = (data) => {

    if(data.invoice_id > 0){
        //location.href = '/fatura/'+data.invoice_id
        router.push('/fatura/'+data.invoice_id);
    }
    else{
        emit('edit', data);
    }

}

const payTrasaction = (data) => {
    emit('pay', data);
}

const is_taled = (date, state) => {
    let data = new Date(date);

    if(data.setDate(data.getDate() + 1) < new Date() && state == 'Unpaid'){
        
        return true;

    }
    else{
        return false;
    }
}

const getContrastYIQ = (hexcolor) => {
    var r = parseInt(hexcolor.substring(1,3),16);
    var g = parseInt(hexcolor.substring(3,5),16);
    var b = parseInt(hexcolor.substring(5,7),16);
    var yiq = ((r*299)+(g*587)+(b*114))/1000;
    return (yiq >= 128) ? 'black' : 'white';
}
</script>

<template>
    <div :id="'transaction'+ transaction.id" class="col-12 border-bottom pt-2 pt-md-0 pb-2 pb-md-0">

        <div class="row align-items-center row-transactions">

            <div class="col-2 col-sm-1 ms-2 me-2 me-lg-0 text-center d-none d-lg-block" v-tooltip="{
                            content: transaction.category_name,
                            distance: 15
                        }">
                <div class="text-center shadow icon icon-shape align-self-center rounded-5" :style="'background-color: '+transaction.category_color">
                    <i :class="'fal ' + transaction.category_icon +' row-transactions-icons' " :style="'color:'+getContrastYIQ(transaction.category_color)"></i>
                </div>
            </div>

            <div v-if="transaction.invoice_id > 0" class="col-10 col-sm-8" @click="editTrasaction(transaction)">
                <div class="row align-items-center">
                    <div class="col-8 col-sm-6 cursor-pointer" v-tooltip="{
                                                content:t('message.global.see_details'),
                                                distance: 15
                                            }">
                        
                        <h6 class="mb-0 text-md transaction-description">{{ transaction.description }} {{ transaction.recurrence == 'Installments' ? '('+transaction.current_installment+'/'+transaction.end_installment+')' : '' }}</h6>
                        <p class="text-sm mt-n1" v-if="transaction.type == 'transferência'">
                            {{ transaction.account_name }} para {{ transaction.account_destiny_name }}
                        </p>
                        <p class="text-sm mt-n1" v-if="(transaction.customer_suplier_id > 0)">
                            para {{ transaction.customer_supplier_name }}
                        </p>
                        <div class="col-12 d-md-none">
                            <span class="badge badge-sm mt-2 fs-10 p-2" :style="'background-color: '+transaction.category_color + '; color:'+getContrastYIQ(transaction.category_color)">
                                <i class="fs-10 me-1" :class="'fal ' + transaction.category_icon +' row-transactions-icons' " :style="'color:'+getContrastYIQ(transaction.category_color)"></i>
                                {{ transaction.category_name }}
                            </span>
                            
                        </div>
                    </div>
                    <div class="col-12 col-sm-3 text-sm-center d-none d-sm-block">
                        <img :src="transaction.account_icon" width="32" alt="" class="rounded-5" v-tooltip="{
                                                content:transaction.account_name,
                                                distance: 15
                                            }">
                    </div>
                    <div class="col-4 col-sm-3 text-center">
                        <p class="mb-1 text-sm fs-14">
                            {{ formatDate(transaction.date) }} <span v-if="is_taled(transaction.date, transaction.status)" class="badge badge-sm bg-warning mb-1 ms-1"> {{t('message.global.overdue')}}</span>
                        </p>
                        <spam class="mb-0 text-md fs-16" :class="transaction.type == 'despesa' ? 'text-danger' : transaction.type == 'receita' ? 'text-success' : ''">{{ formatMoney(transaction.amount) }}</spam>
                    </div>
                </div>
            </div>

            <div v-else class="col-10 col-sm-8" @click="editTrasaction(transaction)" data-bs-toggle="modal" data-bs-target="#detailsTransaction">
                <div class="row align-items-center mt-1">
                    <div class="col-8 col-sm-6 cursor-pointer" v-tooltip="{
                                                content:t('message.global.see_details'),
                                                distance: 15
                                            }">
                       
                       
                        <h6 class="mb-0 text-md transaction-description">{{ transaction.description }} {{ transaction.recurrence == 'Installments' ? '('+transaction.current_installment+'/'+transaction.end_installment+')' : '' }}</h6>
                        <p class="text-sm mt-n1" v-if="transaction.type == 'transferência'">
                            {{ transaction.account_name }} para {{ transaction.account_destiny_name }}
                        </p>
                        <p class="text-sm mt-n1 mb-0" v-if="(transaction.customer_suplier_id > 0)">
                            para {{ transaction.customer_supplier_name }}
                        </p>
                        <div class="col-12 d-md-none">
                            <span class="badge badge-sm mt-2 fs-10 p-2" :style="'background-color: '+transaction.category_color + '; color:'+getContrastYIQ(transaction.category_color)">
                                <i class="fs-10 me-1" :class="'fal ' + transaction.category_icon +' row-transactions-icons' " :style="'color:'+getContrastYIQ(transaction.category_color)"></i>
                                {{ transaction.category_name }}
                            </span>
                            
                        </div>
                    </div>
                    <div class="col-12 col-sm-3 text-sm-center d-none d-sm-block">
                        <img :src="transaction.account_icon" width="32" alt="" class="rounded-5" v-tooltip="{
                                                content:transaction.account_name,
                                                distance: 15
                                            }">
                    </div>
                    <div class="col-4 col-sm-3 text-center">
                        <p class="mb-1 text-sm fs-14">
                            {{ formatDate(transaction.date) }} <span v-if="is_taled(transaction.date, transaction.status)" class="badge badge-sm bg-warning mb-1"> Em atraso</span>
                        </p>
                        <span 
                            class="mb-0 text-md fs-16" 
                            :class="transaction.type == 'despesa' ? 'text-danger' : transaction.type == 'receita' ? 'text-success' : ''"
                        >
                            {{ formatMoney(transaction.amount) }}
                        </span>
                    </div>
                    
                </div>
            </div>
            
            <div class="col-2 col-sm-2 text-end">
                <a @click="payTrasaction(transaction)" class="me-lg-3 cursor-pointer">
                    <i 
                        class="fa-thumbs-up row-transactions-icons-actions"
                        :class="transaction.status == 'Unpaid' ? darkmode ? 'fal text-white-50' : 'fal text-black-50' : 'fas text-success'"
                        v-tooltip="{
                            content: transaction.type == 'despesa' ? transaction.status == 'Unpaid' ? t('message.transactions.paying_button_expense') : t('message.global.payed') : transaction.status == 'Unpaid' ? t('message.transactions.paying_button_revenue') : t('message.global.received'),
                            distance: 15
                        }"
                    >
                    </i>
                </a>
                <div class="col-12 col-lg-3 text-lg-center d-sm-none  mt-3">
                    <img :src="transaction.account_icon" width="26" alt="" class="rounded-5" v-tooltip="{
                                                content:transaction.account_name,
                                                distance: 15
                                            }">
                </div>
                
            </div>

        </div>

    </div>
</template>

<style>
    .row-transactions{
        min-height: 85px;
    }

    .hover-transaction{
        border-bottom: solid 1px #dee2e6;
    }

    .hover-transaction:hover{
        background-color: #f6f9fc;
        cursor: pointer;
    }

    .row-transactions-icons{
        font-size: 25px;
    }

    .row-transactions-icons-actions{
        font-size: 20px;
    }

    .color-paid {
        color: #2dce89 !important;
    }

    .transaction-description{
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }

    .sticky-top{
        z-index: 900 !important;
    }

    .transaction-taled{
        background-color: #d18536;
    }

    .transaction-taled.darkmode{
        background-color: #d186367e;
    }
</style>